<template>
  <modal-wrapper
    v-bind="$attrs"
    width="90%"
    height="auto"
    :scrollable="true"
    :name="name"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @close="close"
  >
    <template #content>
      <div class="hotel-abs">
        <header class="hotel-abs__header">
          <abs-popup-description
            :img="require('@/assets/content/ocean-256.jpg')"
            name="OceanView"
            description="The best things in life are ocean views are so fucking cool its so fun to be fucking fun it’s so great wow. Oh wow buy it now. So let’s buy guys ok? Let’s"
          />
          <div class="tabs">
            <ul class="tabs__list">
              <li
                class="tabs__item"
                :class="{
                  'is-active': activeTab === 'breakdown',
                }"
              >
                <a
                  href="#"
                  @click.prevent="activeTab = 'breakdown'"
                >Breakdown</a>
              </li>
            </ul>
          </div>
        </header>
        <div class="hotel-abs__content">
          <div
            v-if="activeTab === 'breakdown'"
            class="tabs-panel"
          >
            <data-table
              :headers="sourcesHeaders"
              :rows="sourcesList"
            />
          </div>
        </div>
      </div>
    </template>
  </modal-wrapper>
</template>
<script>
import ModalWrapper from '@/components/modals/ModalWrapper';
import AbsPopupDescription from '@/components/AbsPopupDescription';
import DataTable from '@/components/DataTable';

const name = 'modal-hotel-abs';

export default {
  name,
  components: {
    ModalWrapper,
    DataTable,
    AbsPopupDescription,
  },
  data() {
    return {
      name,
      isLoading: false,
      data: null,
      activeTab: 'breakdown',
      sourcesHeaders: [
        'Supplier',
        'Cheapest Room',
        'Rate',
        'Suppliers',
        'Room w/ Matching Attribute',
        'Rate',
        'Attribute',
        'Price Difference',
        'Recommended Sell Price',
      ],
      sourcesList: [
        [
          { text: 'Hotelbeds' },
          { text: 'Double Standard' },
          { text: '$100' },
          { text: 'Expedia' },
          { text: 'Double Standard (Twin) OVW' },
          { text: '$130' },
          { text: 'Ocean View' },
          { text: '$30' },
          { text: '$45', className: 'price' },
        ],
        [
          { text: 'Hotelbeds' },
          { text: 'Double Standard' },
          { text: '$100' },
          { text: 'Expedia' },
          { text: 'Double Standard (Twin) OVW' },
          { text: '$130' },
          { text: 'Ocean View' },
          { text: '$30' },
          { text: '$45', className: 'price' },
        ],
        [
          { text: 'Hotelbeds' },
          { text: 'Double Standard' },
          { text: '$100' },
          { text: 'Expedia' },
          { text: 'Double Standard (Twin) OVW' },
          { text: '$130' },
          { text: 'Ocean View' },
          { text: '$30' },
          { text: '$45', className: 'price' },
        ],
        [
          { text: 'Hotelbeds' },
          { text: 'Double Standard' },
          { text: '$100' },
          { text: 'Expedia' },
          { text: 'Double Standard (Twin) OVW' },
          { text: '$130' },
          { text: 'Ocean View' },
          { text: '$30' },
          { text: '$45', className: 'price' },
        ],
        [
          { text: 'Hotelbeds' },
          { text: 'Double Standard' },
          { text: '$100' },
          { text: 'Expedia' },
          { text: 'Double Standard (Twin) OVW' },
          { text: '$130' },
          { text: 'Ocean View' },
          { text: '$30' },
          { text: '$45', className: 'price' },
        ],
      ],
    };
  },
  methods: {
    close() {
      this.$modal.hide(this.name);
    },
    closeByEscape(e) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
    async beforeOpen(event) {
      const loader = this.$loading.show();
      this.isLoading = true;

      this.data = null;
      this.activeTab = 'breakdown';

      if (event.params) {
        this.data = event.params.data || null;
        this.activeTab = event.params.activeTab || 'breakdown';
      }

      document.addEventListener('keyup', this.closeByEscape);

      loader.hide();
      this.isLoading = false;
    },
    beforeClose() {
      document.removeEventListener('keyup', this.closeByEscape);
    },
  },
};
</script>
<style lang="scss" scoped>
.hotel-abs {
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  &__header {
    background: #f7f9fc;
    color: #6e7c91;
    padding: 30px 30px 0;
    flex: 0 0 1%;
  }
  &__content {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .tabs {
    margin-left: -20px;
    font-size: 13px;
    line-height: 16px;
    font-weight: bold;
    text-transform: uppercase;
    &__list {
      display: flex;
    }
    &__item {
      a {
        display: block;
        padding: 13px 20px;
        position: relative;
        text-decoration: none;
        color: currentColor;
        &:after {
          content: '';
          position: absolute;
          height: 4px;
          background: currentColor;
          bottom: -2px;
          border-radius: 2px;
          left: 7px;
          right: 7px;
          opacity: 0;
          transition: opacity 0.15s ease-in-out;
        }
      }
      &.is-active a {
        color: #6972de;
        &:after {opacity: 1;}
      }
    }
  }
}
.tabs-panel {
  height: 100%;
  overflow: auto;
  padding: 10px;
}
</style>
